export interface SubscriptionHistory {
    id?: number;
    payment_date?: string;
    type?: string | null;
    logo?: string | null;
    plan_name?: string;
    start_date?: string;
    end_date?: string;
    status?: "Active" | "Deactive";
    sub_total?: number;
    discount?: number;
    tax?: number;
    total?: number;
    card_number?: string | null;
    invoice?: string | null;
}

// to single object maping
export const mapSubscriptionHistory = (data: any): SubscriptionHistory => {
    if (!data) {
        throw new Error("Invalid Data");
    }
    const res: SubscriptionHistory = {
        id: data.id,
        payment_date: data.payment_date,
        type: data.type,
        logo: data.logo,
        plan_name: data.plan_name,
        start_date: data.start_date,
        end_date: data.end_date,
        status: data.status,
        sub_total: data.sub_total,
        discount: data.discount,
        tax: data.tax,
        total: data.total,
        card_number: data.card_number,
        invoice: data.invoice,
    };
    return res;
};

// maping list objects
export const mapSubscriptionHistorys = (data: any[]): SubscriptionHistory[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }
    return data.map(mapSubscriptionHistory);
};
